<div class="content-container">
  <div class="slide-container-ii">

    <!-- Page 0 -->
    <div class="content-ii">
      <img class="import-img" src="./assets/images/import_itunes.png">
      <p>{{getString('importiTunesPage1Text1')}}</p>
      <p>{{getString('importiTunesPage1Text2')}}</p>
      <p>{{getString('importiTunesPage1Text3')}}</p>
    </div>
    <!-- Page 1 -->
    <div class="content-ii">
      <h2>{{getString('whatOSDoYouUse')}}</h2>
      <p class="red-text uppercase">{{getString('important')}}</p>
      <p>{{getString('importiTunesPage15Text1')}}</p>
      <p>{{getString('importiTunesPage15Text2')}}</p>
      <p>
        {{getString('importiTunesPage15Text5')}}<br/>
        {{getString('importiTunesPage15Text3')}}<br/>
        <button class="blue-button" (click)="isV2 = true; pages = 4; next()">{{getString('clickHere')}}</button>
      </p>
      <p>
        {{getString('importiTunesPage15Text5')}}<br/>
        {{getString('importiTunesPage15Text4')}}<br/>
        <button class="blue-button" (click)="next()">{{getString('clickHere')}}</button>
      </p>
    </div>
    <!-- Page 2 (v1)-->
    <div *ngIf="!isV2" class="content-ii">
      <h2>{{getString('stepByStep')}}</h2>
      <p>{{getString('importiTunesPage2Text1')}}</p>
      <p>{{getString('importiTunesPage2Text2')}}</p>
      <p>{{getString('importiTunesPage2Text3')}}</p>
      <p>{{getString('importiTunesPage2Text4')}}</p>
      <p>{{getString('importiTunesPage2Text5')}}</p>
    </div>
    <!-- Page 2 (v2) -->
    <div *ngIf="isV2" class="content-ii">
      <h2>{{getString('stepByStep')}}</h2>
      <p><span [innerHTML]="getString('importiTunesPage16Text1')"></span><a class="blue-link" href="https://youtu.be/-_iCjT67l0E" target='_blank'>{{getString('link')}}</a></p>
      <p>{{getString('importiTunesPage16Text2')}}</p>
      <textarea [(ngModel)]="v2DataToUpload"></textarea>
    </div>
    <!-- Page 3 (v1)-->
    <div *ngIf="!isV2" class="content-ii">
      <div *ngIf="!isUploading">
        <p>{{getString('importiTunesPage3Text1')}}</p>
        <button type="button" (click)="chooseFile()">{{getString('choose')}}</button>
        <span *ngIf="fileOK == true" class="green-text">{{getString('fileOK')}}</span>
        <span *ngIf="invalidFile == true" class="red-text">{{getString('invalidFile')}}</span>
        <span *ngIf="fileTooBig == true" class="red-text">{{getString('fileExceeds128MB')}}</span>
        <input #browseInput type="file" (change)="handleSelectedLocalFiles($event)" class="browse-input" value="Browse">

        <p>{{getString('importiTunesPage3Text2')}}</p>
        <div class="inline-block">
          <app-custom-checkbox [value]="moviesOn" [label]="getString('movies')" (onChange)="cbMoviesChanged($event)"></app-custom-checkbox>
          <app-custom-checkbox [value]="tvOn" [label]="getString('tv')" (onChange)="cbTVChanged($event)"></app-custom-checkbox>
        </div>
        <p>{{getString('importiTunesPage3Text3')}}</p>
        <p>{{getString('importiTunesPage3Text4')}}</p>
        <div class="red-text">
          {{errorMessage}}
        </div>
      </div>
      <div *ngIf="isUploading" class="spinner-container">
        <app-spinner></app-spinner>
        <div>{{getString('pleaseWait')}}</div>
        <div class="percentage">{{percentage}}%</div>
      </div>
    </div>
    <!-- Page 4 (v1) -->
    <div *ngIf="!isV2" class="content-ii">
      <div *ngIf="uploadSuccessful" class="result-page">
        <h1 class="green-text">{{getString('importSuccessful')}}</h1>
        <p>{{getSuccessCountText()}}</p>
        <p>{{getString('importiTunesPage4SuccessText2')}}</p>
      </div>
      <div *ngIf="!uploadSuccessful" class="result-page">
        <h1 class="red-text">{{getString('importFailed')}}</h1>
        <p>{{getString('importPage4ErrorText2')}}</p>
        <p>{{getErrorMessageText()}}</p>
        <p>{{getString('importPage4ErrorText3')}}</p>
      </div>
    </div>
    <!-- Page 3 (v2) -->
    <div *ngIf="isV2" class="content-ii">
      <div *ngIf="uploadSuccessful" class="result-page">
        <h1 class="green-text">{{getString('importSuccessful')}}</h1>
        <p>{{getSuccessCountText()}}</p>
        <p>{{getString('importiTunesPage4SuccessText3')}}</p>
        <textarea [(ngModel)]="importv2Results"></textarea>
      </div>
      <div *ngIf="!uploadSuccessful" class="result-page">
        <h1 class="red-text">{{getString('importFailed')}}</h1>
        <p>{{getString('importPage4ErrorText2')}}</p>
        <p>{{getErrorMessageText()}}</p>
        <p>{{getString('importPage4ErrorText3')}}</p>
      </div>
    </div>

  </div>
  <div class="page-number">{{currentPageNo + 1}}/{{pages}}</div>
  <div class="btn-container">

    <button type="button" class="back-button float-left" (click)="back()" *ngIf="currentPageNo > 0 && (!isV2 && currentPageNo < 4) || (isV2 && currentPageNo < 3)">{{getString('back')}}</button>

    <button type="button" class="blue-button float-right"
      (click)="next()"
      *ngIf="currentPageNo != 1 && currentPageNo < pages - 1 && !isUploading"
      [disabled]="isV2 && !v2DataToUpload"
    >
      <span *ngIf="currentPageNo != 3 && (!isV2 || currentPageNo != 2)">{{getString('next')}}</span>
      <span *ngIf="(!isV2 && currentPageNo == 3) || (isV2 && currentPageNo == 2)">{{getString('start')}}</span>
    </button>
    <button type="button" class="blue-button float-right" (click)="close()" *ngIf="currentPageNo == pages - 1">
      {{getString('done')}}
    </button>
  </div>

</div>
